import ActivityCard from "components/ActivityPanel/ActivityCard";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import ExcelTemplateActivityCardContent from "./ExcelTemplateActivityCardContent";

interface Props {
  activity: server.dto.ExcelTemplateActivity
}

export const ExcelTemplateActivityCard = (props: Props) => {
  const { activity } = props;
  const { timestampUtc, action } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  const title = action.text;
  const subtitles = [`${timstampUtcMoment.fromNow()}`];

  return <ActivityCard
    activity={activity}
    getTitle={() => title}
    getSubtitle={() => subtitles}
    getSubtitleHover={() => formatWrittenDateTimeUtc(timstampUtcMoment)}>
    <ExcelTemplateActivityCardContent activity={activity} />
  </ActivityCard>
}